module.exports = __webpack_public_path__ + "img/cash.2f554e32.svg";